/* @ngInject */
function TaskRatingStarsController ($scope) {
  const DEFAULT_MAX_STARS = 5
  const DEFAULT_SELECTED_STARS = 0
  $scope.stars = []

  const api = {
    _createStarsOnScreen,
    _emitClickEvt
  }
  this.getApi = () => api

  activate()
  function activate () {
    $scope.starsCount = $scope.starsCount || DEFAULT_MAX_STARS // default is 5
    $scope.selectedStars = $scope.selectedStars || DEFAULT_SELECTED_STARS // default is 0
    $scope.readOnly = !!$scope.readOnly

    api._createStarsOnScreen($scope.starsCount)
  }

  $scope.toggleSelected = (starIndex) => {
    const clickedStar = $scope.stars[starIndex]

    if (clickedStar.selected) {
      for (let i = $scope.starsCount - 1; i > starIndex; i--) {
        $scope.stars[i].selected = false
      }
    } else {
      for (let i = 0; i <= starIndex; i++) {
        $scope.stars[i].selected = true
      }
    }

    const selectedStars = starIndex + 1 // selectedStars needs to start in 1 while starIndex starts in 0 cause it's an array, that's why we sum 1 to starIndex
    api._emitClickEvt(selectedStars)
  }

  function _emitClickEvt (selectedStars) {
    $scope.$emit('ratingStars-changed-value', {
      value: selectedStars
    })
  }

  function _createStarsOnScreen (starsCount) {
    for (let i = 0; i < starsCount; i++) {
      const star = {
        readOnly: $scope.readOnly,
        selected: Boolean(i < $scope.selectedStars)
      }

      $scope.stars.push(star)
    }
  }
}

export { TaskRatingStarsController }
